export function makeFlagEmoji(countryCode: string): string {
  const OFFSET = 127397;
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => OFFSET + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}
